import { render, staticRenderFns } from "./ProfesorGestionMateriales.vue?vue&type=template&id=0e12d1b0&"
import script from "./ProfesorGestionMateriales.vue?vue&type=script&lang=js&"
export * from "./ProfesorGestionMateriales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports